import React from "react";
import styled from "styled-components";
import { colors } from "../styles/colors";
import { motion } from "framer-motion";

const AboutSection = styled.section`
  padding: 60px 20px 120px 20px; 
  text-align: center;
  background-color: ${colors.background};
`;

const Subtitle = styled.span`
  font-family: 'Montserrat', sans-serif;
  font-size: 1.15rem;          
  font-weight: 700;            
  text-transform: uppercase;
  letter-spacing: 0.25em;      
  color: ${colors.primary};
  display: block;
  margin-bottom: 20px;         
`;

const Heading = styled.h2`
  font-family: 'Playfair Display', serif;
  font-size: 2.5rem;
  font-weight: 600;
  margin-bottom: 30px;
  color: ${colors.secondary};
`;

const Text = styled.p`
  font-family: 'Montserrat', sans-serif;
  max-width: 800px;           
  margin: 0 auto;
  line-height: 1.8;
  font-size: 1.15rem;         
  color: #555555;
`;

const Divider = styled.div`
  width: 110px;               
  height: 40px;
  margin: 10px auto 0 auto;
  border-bottom: 2px solid ${colors.primary};
`;

export default function About() {
  return (
    <AboutSection id="about">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <Subtitle>Strategy • Growth • Impact</Subtitle>
        <Heading>About Me</Heading>
        <Text>
          I’m Saleha Safdar, based in the UAE, with over five years of experience helping businesses and individuals bring their projects to life. I work with expert teams across different industries to provide the right solutions and ensure every project is completed efficiently and successfully. My goal is to simplify complex projects, deliver practical results, and make the entire process smooth and reliable for my clients.
        </Text>
        <Divider />
      </motion.div>
    </AboutSection>
  );
}